import { Stack, Switch, Typography } from '@mui/material'

export function AddTranslationsBulkImport({
  checked,
  handleChange,
}: {
  checked: boolean
  handleChange: (checked: boolean) => void
}) {
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        sx={{
          gap: '2px',
        }}
      >
        <Typography fontWeight="medium">Add Translations</Typography>
        <Typography color="#475467" variant="xs">
          Auto-translate missing fields
        </Typography>
      </Stack>
      <Switch
        checked={checked}
        onChange={(_, c) => {
          handleChange(c)
        }}
      />
    </Stack>
  )
}
